


































































import { Facet } from '@empathy/search-types';
import Component from 'vue-class-component';
import { Mixins, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { FacetConfig, ShowSelectedFilters } from '../../../models';
import { GETTERS_KEYS, SUBMODULES_PATHS } from '../../../store';
import { SEARCH_GETTERS_KEYS } from '../../../store/search/search.const';
import { FacetsGroupMixin } from '../../mixins/facets-group.mixin';

@Component({
  computed: {
    ...mapGetters(SUBMODULES_PATHS.search, {
      selectedFiltersByFacet: SEARCH_GETTERS_KEYS.selectedFiltersByFacet,
      compulsoryFacets: SEARCH_GETTERS_KEYS.compulsoryFacets
    })
  }
})
export default class FacetComponent extends Mixins(FacetsGroupMixin) {
  @Prop({ required: true })
  facetName: string;

  get collapsed() {
    return this.facetsGroup.facets[this.facetName].collapsed;
  }

  get facetConfig(): FacetConfig {
    return this.$store.getters[GETTERS_KEYS.config.facet](this.facetName, this.groupId) as FacetConfig;
  }

  get facet(): Facet {
    return this.$store.state.search.facets[this.facetName];
  }

  get renderSelectedFilters(): boolean {
    return this.facetConfig.showSelectedFilters === ShowSelectedFilters.Always
      || this.facetConfig.showSelectedFilters === ShowSelectedFilters.WhenCollapsed && this.collapsed
      || this.facetConfig.showSelectedFilters === ShowSelectedFilters.WhenExpanded && !this.collapsed;
  }
}
